import { createContext, useContext, ReactNode } from 'react';
import { AssessmentDetailsTab } from './index.js';

interface AssessmentDetailsContextProps {
  activeTab: AssessmentDetailsTab;
  setActiveTab: (tab: AssessmentDetailsTab) => void;
}

const AssessmentDetailsContext = createContext<
  AssessmentDetailsContextProps | undefined
>(undefined);

export const AssessmentDetailsProvider = ({
  children,
  activeTab,
  setActiveTab
}: {
  children: ReactNode;
  activeTab: AssessmentDetailsTab;
  setActiveTab: (tab: AssessmentDetailsTab) => void;
}) => {
  return (
    <AssessmentDetailsContext.Provider value={{ activeTab, setActiveTab }}>
      {children}
    </AssessmentDetailsContext.Provider>
  );
};

export const useAssessmentDetails = () => {
  const context = useContext(AssessmentDetailsContext);
  if (!context) {
    throw new Error(
      'useAssessmentDetails must be used within an AssessmentDetailsProvider'
    );
  }
  return context;
};
